// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cal-body {\n  border: 2px solid #E0E0E0;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-top: none;\n  padding: 10px 20px;\n  text-align: center;\n}\n.month {\n  font-weight: bold;\n  text-align: center;\n}\n.day {\n  font-family: \"Roboto Slab\", serif;\n  font-size: 2.5em;\n  line-height: 1em;\n  text-align: center;\n}\n.datecolumns {\n  display: flex;\n  justify-content: center;\n}\n.lowdash {\n  padding-top: 22px;\n}", ""]);
// Exports
module.exports = exports;
